export default __webpack_public_path__ + "static/media/chat-message-delete.1af3e5b9.svg";